.j{justify-content:center;}